export default __webpack_public_path__ + "static/media/homeFirstImg.c351c05d.jpg";